"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm2 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12ZM12 5a1 1 0 0 1 1 1v.518c.957.11 1.733.393 2.311.781.748.503 1.179 1.199 1.179 1.917 0 .603-.413 1.068-.972 1.068-.426 0-.72-.214-.922-.518l-.006-.009-.005-.01c-.194-.342-.413-.62-.762-.818A2.484 2.484 0 0 0 13 8.654v2.833c.715.076 1.453.191 2.07.46.457.2.867.49 1.16.925.293.435.452.99.452 1.688 0 1.364-.555 2.364-1.441 3.012-.626.458-1.403.732-2.241.85V19a1 1 0 0 1-2 0v-.575c-2.594-.366-3.718-2.15-3.718-3.161 0-.633.441-1.084 1.02-1.084a.85.85 0 0 1 .665.304c.13.146.243.345.356.547l.039.068c.163.282.385.591.775.835.218.136.498.257.863.337V13.23c-.654-.087-1.313-.222-1.866-.503a2.56 2.56 0 0 1-1.075-.978c-.266-.448-.41-1.012-.41-1.717 0-1.101.468-2.005 1.271-2.625.558-.431 1.268-.719 2.08-.853V6a1 1 0 0 1 1-1Zm-1.743 4.013c.2-.126.45-.228.743-.3v2.557a3.013 3.013 0 0 1-.757-.216 1.004 1.004 0 0 1-.442-.363c-.096-.15-.16-.358-.16-.659 0-.417.205-.763.616-1.019ZM13 16.281v-2.835c.384.055.72.125.991.233.238.094.405.208.513.344.103.13.17.304.17.553 0 .585-.252 1.018-.692 1.316-.26.175-.591.309-.982.389Zm-3.935-1.099c-.183-.323-.311-.55-.511-.648.2.098.329.325.511.648Z",
    clipRule: "evenodd"
  })]
});